import { render, staticRenderFns } from "./work-packages-unit-kpi-icon-new.vue?vue&type=template&id=f6512276&scoped=true"
import script from "./work-packages-unit-kpi-icon-new.vue?vue&type=script&lang=js"
export * from "./work-packages-unit-kpi-icon-new.vue?vue&type=script&lang=js"
import style0 from "./work-packages-unit-kpi-icon-new.vue?vue&type=style&index=0&id=f6512276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6512276",
  null
  
)

export default component.exports